module.exports = __webpack_public_path__ + "img/location.b5797f06.svg";